import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { WapBillingResponseItem, WAPBillingTableData, WapBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: WapBillingResponseItem[],
  actionsHandling: WapBillingTableRowActions
): WAPBillingTableData[] =>
  data.map((wapBillingItem: WapBillingResponseItem) => {
    const { cost, id, ...rest } = wapBillingItem;

    const actions = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actions} />
    };
  });
